<template>
  <div>
    <div class="bg"></div>
    <div class="main">
      <div>
        <div class="titlefont">
          <div class="titleAnimation">
            <div class="title">{{ learning.title }}</div>
            <div class="desc">{{ learning.about }}</div>
          </div>
        </div>
        <div class="conMain boxShow">
          <div class="con">
            <div class="studyRoute">
              <div class="outlineBox">
                <!-- TODO 如果小于8天添加宽度平分-->
                <el-tabs
                  v-model="editableTabsValue"
                  @tab-click="handleClick"
                  :class="{ activeFlex: listData.length < 8 }"
                >
                  <el-tab-pane
                    label
                    v-for="(item, index) in listData"
                    :key="index"
                  >
                    <div slot="label" class="outlineTitle">
                      <p>
                        {{ item.title }}
                      </p>
                      <p>{{ item.subTitle }}</p>
                    </div>
                    <div class="outlineeInfo">
                      <div
                        v-for="(val, num) in item.desc"
                        :key="num"
                        class="items"
                      >
                        <em class="courseOutTitle" v-if="val !== undefined"
                          ><span></span>{{ val.title }}</em
                        >
                        <ul class="courseOutList" v-if="val !== undefined">
                          <li v-for="(v, n) in val.conten" :key="n" :title="v">
                            {{ v }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { statusTabsAddEventListener } from "./../../../../js/tools";
export default {
  components: {},
  props: {
    learning: {
      type: Object,
      default: () => {},
    },
    listData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editableTabsValue: "0",
    };
  },
  methods: {
    handleClick(val) {
      this.$emit("handleClick", val);
    },
    getCaptionReg(str) {
      str = str.split("：")[0];
      return str;
    },
    getCaption(str) {
      let str1 = "";
      if (str.lastIndexOf("(") > 0) {
        str1 = str.substring(str.indexOf("(") + 1, str.indexOf(")"));
      }
      return str1;
    },
    getCaption2(str) {
      let str1 = "";
      if (str.lastIndexOf("(") > 0) {
        str1 = str.substring(str.indexOf("：") + 1, str.indexOf("("));
      }
      return str1;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
